function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 1",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M46.27 54.25L48.83 0H0s2.55 52.45 2.62 54.25zM4.08 3.87h40.67l-1.48 34.88H5.62z"
}), React.createElement("path", {
  d: "M46.27 54.25L48.83 0H0s2.55 52.45 2.62 54.25zM4.08 3.87h40.67l-1.48 34.88H5.62z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48.83 54.25"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/shot.svg";
export { SvgComponent as ReactComponent };